import { getVersion } from './version';
import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import {
	setBankList,
	setCountries,
	setIndustries,
	setPaymentsPurpose,
	setCurrencies,
	setError,
	setAltshulerAccountList,
	setLoading,
	setVersion,
} from 'state/reducers/global.reducer';
import { setError as setErrorRequest } from 'state/reducers/pending-requests.reducer';
import { setErrorMessage } from 'utils/index';
import { setSuccessMessage } from 'state/reducers/ui.reducers';

export function getAllowedCurrencies() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_ALLOWED_CURRENCIES, {})
			.then((response: any) => {
				dispatch(setCurrencies(response.data.allowedCurrencies));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getCountries() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_COUNTRIES, {})
			.then((response: any) => {
				dispatch(setCountries(response.data.countries));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getIndustries() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_INDUSTRIES, {})
			.then((response: any) => {
				dispatch(setIndustries(response.data.industries));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getPaymentsPurpose() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_PAYMENTS_PURPOSE, {})
			.then((response: any) => {
				dispatch(setPaymentsPurpose(response.data.paymentsPurpose));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getBankList() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_BANKS, {})
			.then((response: any) => {
				dispatch(setBankList(response.data.banks));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function updateBankDigitalDepositAvailability(
	data: { bankId: number; isDigitalDepositTemporarilyUnavailable: boolean },
	bankList: any[]
) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPDATE_BANK_DIGITAL_DEPOSIT_AVAILABILITY, data)
			.then((response: any) => {
				const modifiedBankList = bankList.map((bank: any) => {
					return bank.id === data.bankId
						? {
								...bank,
								isDigitalDepositTemporarilyUnavailable: data.isDigitalDepositTemporarilyUnavailable,
						  }
						: bank;
				});
				dispatch(setBankList(modifiedBankList));
				return response;
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getAltshulerBankAccountList() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_ALTSHULER_BANK_ACCOUNTS, {})
			.then((response: any) => {
				dispatch(setAltshulerAccountList(response.data.altshulerAccounts));
			})
			.catch((error: any) => {
				console.log(error);
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export async function getFile(key: string, companyId: number | null = null) {
	const paramsSetting = {
		key,
	};
	const headers = {
		'Content-Type': 'application/octet-stream',
	};
	const additionalParameters = {
		responseType: 'blob',
	};
	await ApiService.getInstance()
		.execute(
			companyId ? apiFunctionsEnum.READ_FILE : apiFunctionsEnum.READ_FILE_BY_KEY,
			companyId ? { ...paramsSetting, companyId } : paramsSetting,
			headers,
			additionalParameters
		)
		.then((response) => {
			const url = window.URL.createObjectURL(
				new Blob([response.data], { type: response.headers['content-type'] })
			);
			window.open(url, '_blank');
		})
		.catch((error) => {
			console.log(error);
		});
}

function writeAppVersionToDom(version: string) {
	const headerMetadataElement = document.querySelector("meta[name='appVersionNumber']");
	if (headerMetadataElement) {
		headerMetadataElement.setAttribute('content', version);
	}
}

export function setAppVersion() {
	return async (dispatch: any) => {
		await getVersion()
			.then((version: string) => {
				writeAppVersionToDom(version);
				dispatch(setVersion(version));
			})
			.catch((error: any) => {
				console.log("can't get version");
				console.log(error);
			});
	};
}

export function editCountry(data: any, countries: any[]) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_COUNTRY, data)
			.then((response: any) => {
				const modifiedCountries = countries?.map((country: any) => {
					return data.id === country.id ? { ...country, ...data } : country;
				});
				dispatch(setCountries(modifiedCountries));
				return response;
			})
			.catch((error: any) => {
				setErrorMessage(setErrorRequest, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function editPaymentsPurpose(data: any, PaymentsPurpose: any[]) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.EDIT_PAYMENTS_PURPOSE, data)
			.then((response: any) => {
				const modifiedPaymentsPurpose = PaymentsPurpose?.map((country: any) => {
					return data.id === country.id ? { ...country, ...data } : country;
				});
				dispatch(setPaymentsPurpose(modifiedPaymentsPurpose));
				dispatch(setSuccessMessage('action.success'));
				return response;
			})
			.catch((error: any) => {
				setErrorMessage(setErrorRequest, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}
